/**
 * All global scripts
 */

document.addEventListener('DOMContentLoaded', (event) => {

    // START header fixed
    const header = document.getElementById('header');

    if ( window.innerWidth > 1200 && header ) {

        window.addEventListener('scroll', function() {
            if(window.scrollY){
                header.classList.add('fixed');
            }
            else{
                header.classList.remove('fixed');
            }
        });
    };
    // END header fixed

	// START Menu mobile
	if ( window.innerWidth < 992 ) {

		const menu = new Mmenu( '#menu', {
			"offCanvas": {
				"position": "right"
			},
			"navbar": {
				"title": "Menu"
			},
		});

		const api = menu.API;

		document.querySelector( "#menu__toggle" ).addEventListener( "click", (event) => {
			if ( document.body.classList.contains('mm-wrapper--opened')) {
				api.close();
			} else {
				api.open();
			}
		});
	}
	// END Menu mobile

	jQuery('.blocgutemberg__chiffreslider__carrousel').slick({
		dots: false,
		infinite: true,
		speed: 300,
		slidesToShow: 4,
		responsive: [
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 2
				}
			}
		]
	});

	jQuery('.blocgutemberg__gallerywithslick__bloc').slick();

}); // end DOMContentLoaded